import React, { Component } from 'react';
import '../SideDraw/folders.css';
import { Tooltip } from 'devextreme-react/tooltip';
import * as updateWorkplace from "../../../images/icons/Refresh.svg";

class UpdateWorkplace extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           
            withAnimationVisible: false,
          
        };
      
        this.toggleWithAnimation = this.toggleWithAnimation.bind(this);

    }

    render() {

        return (
            <div>
                <img
                    id="product4"
                    onMouseEnter={this.toggleWithAnimation}
                    onMouseLeave={this.toggleWithAnimation}
                    style={{ height: '30px', width: '32px', zIndex: 10, color: "#fff", marginTop: '-47px', marginRight: '50px' }}
                    src={updateWorkplace} />
                <Tooltip
                    target="#product4"
                    position="top"
                   
                    visible={this.state.withAnimationVisible}
                    closeOnOutsideClick={false}
                >
                    <div>Update Context</div>
                </Tooltip>
            </div>

        );


    }
    //toggleDefault() {
    //    this.setState({
    //        defaultVisible: !this.state.defaultVisible
    //    });
    //}

    //toggleWithTemplate() {
    //    this.setState({
    //        withTemplateVisible: !this.state.withTemplateVisible
    //    });
    //}

    toggleWithAnimation() {
        this.setState({
            withAnimationVisible: !this.state.withAnimationVisible
        });
    }
}
export default UpdateWorkplace;





// WEBPACK FOOTER //
// ./src/components/TaskView/WorkPlace/UpdateWorkplace.js